<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>
                                  <e-column field='' width='100' headerText=''  :allowSorting='false' :allowFiltering='false' :template='imgTemplate'></e-column>  
                                  <e-column field='style_id' headerText='款式編號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                  <e-column field='style_name' headerText='款式名稱' width='180'></e-column>  
                                  <e-column field='std_pages' headerText='每卷張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='service_years' headerText='使用年限' width='140' format="N0" textAlign="Right"></e-column>  
                                  <e-column field='enable_months' headerText='啟用期限' width='140' format="N0" textAlign="Right"></e-column>  
                                  <e-column field='now_volumes' headerText='現有卷數' width='140' format="N0" textAlign="Right"></e-column>  
                                  <e-column field='now_pages' headerText='現有張數' width='140' format="N0" textAlign="Right"></e-column>  
                                  <e-column field='memo' headerText='備註' width='220'></e-column>                             
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增標籤款式" : "修改標籤款式" + (e_state == 1 ? "(啟用中)" : "(停用中)")' :buttons='e_buttons' 
                        width='500px'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                          
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">款式編號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_style_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                              
                                </div>
                                <div class="form-group col-md-6">                                                  
                                </div>  
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">款式名稱</span>
                                    <ejs-textbox floatLabelType="Always" v-model="e_style_name" aria-required="true"></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">每卷張數</span>
                                  <ejs-numerictextbox id="numeric" format="###,###,### 張" v-model="e_std_pages"></ejs-numerictextbox>   
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">使用年限</span>
                                    <ejs-numerictextbox id="numeric" format="### 年" v-model="e_service_years" min=0 max="20"  @change="onServiceYearsChange"></ejs-numerictextbox>
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">啟用期限</span>
                                  <ejs-numerictextbox id="numeric" format="### 月" :enabled="false" v-model="e_enable_months" min=0 max="20"></ejs-numerictextbox>   
                                </div>
                                <div class="form-group col-md-12">
                                  <span class="about-title">款式圖片</span>
                                  <label class="btn btn-ghost-success">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                </label>
                                <div class="c-avatar" style="height:80px; padding-left: 100px; height:auto; text-align:left"><img v-bind:src="e_image_path_url" class="c-avatar-about-img" /></div>   
                                </div>
                                <div class="form-group col-md-12">
                                  <span class="about-title">備註</span>
                                  <ejs-textbox floatLabelType="Always" :rows="2" :multiline="true" v-model="e_memo"  aria-required="true"></ejs-textbox>    
                                </div>   
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
  </template>
  
  
  
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script lang="ts">
  
  import Vue from "vue";
  import Loading from 'vue-loading-overlay';
  import { DialogUtility } from '@syncfusion/ej2-popups';
  import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
  import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
  import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
  import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
  import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
  
  
  setCulture('en-US');
  L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
  });
  
  enableRipple(true);
  Vue.use(DialogPlugin);
  Vue.use(TooltipPlugin);
  Vue.use(GridPlugin);
  Vue.use(Loading);
  
  let DialogObj   = undefined;
  let Loader      = undefined;
  
  export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent,
    'ejs-numerictextbox': NumericTextBoxComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData : null,   
      e_isAdd: null, e_style_id: null, e_style_name: null, e_std_pages: null, 
      e_service_years: null, e_enable_months: null, e_image_path: null, e_image_path_url: null, e_state: null, e_memo: null,
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],  
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false  ,
      imgTemplate: function () { return { 
          template: Vue.component("imgTemplate", {
          template:  `<div><img :src="image" class='c-avatar-about-img' style='height:100%' /></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.image_path_url;
              }
          }
      })}},    
    };
  },
  methods: {    
    toolbarClick: function (args) {
      if (args.item.id == 'Start' || args.item.id == 'Stop' ) {
        DialogObj = DialogUtility.confirm({
            title: '狀態變更',
            content: `確認是否要${this.e_state == 0 ? '啟用' : '停用'}${this.e_selectData.style_name}的資料嗎?`,
            okButton: {  text: '是', click: this.statusOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除${this.e_selectData.style_name}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    
        this.e_isAdd = true;
        this.e_style_id = "";
        this.e_style_name = "";
        this.e_std_pages = "";
        this.e_service_years= "5";
        this.e_enable_months = "60";
        this.e_image_path = "";
        this.e_memo = "";
        this.e_state = 1;  
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick();
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'部門資料.xlsx' });
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onServiceYearsChange: function() {
      this.e_enable_months = this.e_service_years * 12;
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar = this.e_state == 0 ? 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },
        { text: '啟用', tooltipText: '啟用', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'Start', disabled: this.e_selectRow == undefined },     
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'] : 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },
        { text: '停用', tooltipText: '停用', prefixIcon: 'e-btn-icon e-circle e-icons e-icon-left', id: 'Stop', disabled: this.e_selectRow == undefined },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search']
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');        
      this.e_selectData = args.data;
      this.e_state  = this.e_selectData.state == 1; 
      this.checkHeader();
    },
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStyle',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            style_id: this.e_selectData.style_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getLBStyle();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },   
    statusOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStyle/State',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            style_id: this.e_selectData.style_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('修改成功!');         
        this.hideLoading();
        this.getLBStyle();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },         
    delCancelClick: function() {
        DialogObj.hide();
    },    
    editOkClick: function() {       
      this.showLoading();
      this.axios({
          method: this.e_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStyle',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            style_id: this.e_style_id,
            style_name: this.e_style_name,     
            std_pages : this.e_std_pages,
            service_years : this.e_service_years,
            enable_months : this.e_enable_months,
            image_path : this.e_image_path,            
            memo:  this.e_memo,         
            state: this.e_state ? 1 : 2
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBStyle();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
  
    },  
    recordDoubleClick: function () {         
      this.e_isAdd = false;
      this.e_style_id       = this.e_selectData.style_id ; 
      this.e_style_name     = this.e_selectData.style_name; 
      this.e_std_pages      = this.e_selectData.std_pages; 
      this.e_service_years  = this.e_selectData.service_years; 
      this.e_enable_months  = this.e_selectData.enable_months; 
      this.e_enable_months  = this.e_selectData.enable_months; 
      this.e_image_path     = this.e_selectData.image_path; 
      this.e_image_path_url = this.e_selectData.image_path_url; 
      this.e_memo           = this.e_selectData.memo; 
      this.e_state          = this.e_selectData.state == 1; 
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    fileImageChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/LBStyle/Upload',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) { 

          self.e_image_path = response.data.datas;
          self.e_image_path_url = response.data.msg; 
      
      }).catch((error) => { this.showError(error, false) })
    },  
    getLBStyle: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStyle',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBStyle();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
  }
  </script>
  <style>
  /* 設定 CustomerName 欄位的字體顏色 */
  .blue-text {
  color: blue !important;
  }
  </style>
  <style lang="scss" src="../../scss/base.scss"></style>
  